import { render, staticRenderFns } from "./AgingReport.vue?vue&type=template&id=532f2bf2&scoped=true"
import script from "./AgingReport.vue?vue&type=script&lang=js"
export * from "./AgingReport.vue?vue&type=script&lang=js"
import style1 from "./AgingReport.vue?vue&type=style&index=1&id=532f2bf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f2bf2",
  null
  
)

export default component.exports